// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables and Theme Definitions */
:root {
  --primary-color: #1e3a5f;
  --primary-dark: #152a47;
  --primary-light: #3d5a80;
  --primary-lighter: #e3e9f0;
  --secondary-color: #c9822e;
  --secondary-dark: #a56821;
  --secondary-light: #e0a050;
  --accent-color: #c9822e;
  --accent-dark: #a56821;
  --accent-light: #e0a050;
  --background-color: #faf7f0;
  --background-gradient: #faf7f0;
  --brand-gradient: #1e3a5f;
  --brand-gradient-hover: #152a47;
  --brand-gradient-solid: #1e3a5f;
  --brand-gradient-solid-hover: #152a47;
  --brand-glow: rgba(30, 58, 95, 0.25);
  --brand-glow-accent: rgba(201, 130, 46, 0.2);
  --menu-item-hover-color: #152a47;
  --menu-item-hover-bg: rgba(227, 233, 240, 0.9);
  --card-background: #ffffff;
  --menu-background: #ffffff;
  --card-hover: #f1ece0;
  --text-primary: #1a1a1a;
  --text-secondary: #4a4a4a;
  --text-tertiary: #8a8a8a;
  --text-light: #faf7f0;
  --border-color: rgba(30, 58, 95, 0.12);
  --success-color: #10b981;
  --warning-color: #c9822e;
  --danger-color: #c0392b;
  --box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --box-shadow-md:
    0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --box-shadow-lg:
    0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --box-shadow-xl:
    0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  --box-shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --transition-speed: 0.2s;
  --transition-spring: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  --transition-smooth: cubic-bezier(0.4, 0, 0.2, 1);
  --border-radius: 16px;
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 24px;
  --border-radius-xl: 32px;
  --glass-bg: #ffffff;
  --glass-border: rgba(30, 58, 95, 0.08);
  --backdrop-blur: none;
  --navbar-height: 40px;
  --navbar-total-height: 88px; /* navbar height + padding + increased gaps */
  --group-tabs-height: 56px;
  --navbar-rendered-height: var(--navbar-total-height);
  --group-tabs-rendered-height: var(--group-tabs-height);
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;
}

/* Dark mode theme */
[data-theme='dark'] {
  --background-color: #1a1815;
  --background-gradient: #1a1815;
  --card-background: #24211d;
  --menu-background: #24211d;
  --card-hover: #2e2a25;
  --text-primary: #f0ebe0;
  --text-secondary: #c4bfb5;
  --text-tertiary: #8a8579;
  --text-light: #1a1815;
  --border-color: rgba(240, 235, 224, 0.1);
  --glass-bg: #24211d;
  --glass-border: rgba(240, 235, 224, 0.08);
  --primary-color: #6b8cae;
  --primary-dark: #5a7a9d;
  --primary-light: #8fa6c0;
  --primary-lighter: #2e3a4a;
  --brand-gradient: #6b8cae;
  --brand-gradient-hover: #8fa6c0;
  --brand-gradient-solid: #6b8cae;
  --brand-gradient-solid-hover: #8fa6c0;
  --brand-glow: rgba(107, 140, 174, 0.4);
  --brand-glow-accent: rgba(224, 160, 80, 0.3);
  --menu-item-hover-color: #e0a050;
  --menu-item-hover-bg: rgba(46, 42, 37, 0.8);
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,oCAAoC;EACpC,4CAA4C;EAC5C,gCAAgC;EAChC,8CAA8C;EAC9C,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,sCAAsC;EACtC,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB;qEACmE;EACnE;wEACsE;EACtE;0EACwE;EACxE;2EACyE;EACzE,uDAAuD;EACvD,wBAAwB;EACxB,2DAA2D;EAC3D,iDAAiD;EACjD,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B,EAAE,6CAA6C;EAC1E,yBAAyB;EACzB,oDAAoD;EACpD,sDAAsD;EACtD,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;EACnB,yCAAyC;EACzC,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,sCAAsC;EACtC,4CAA4C;EAC5C,gCAAgC;EAChC,2CAA2C;AAC7C","sourcesContent":["/* CSS Variables and Theme Definitions */\n:root {\n  --primary-color: #1e3a5f;\n  --primary-dark: #152a47;\n  --primary-light: #3d5a80;\n  --primary-lighter: #e3e9f0;\n  --secondary-color: #c9822e;\n  --secondary-dark: #a56821;\n  --secondary-light: #e0a050;\n  --accent-color: #c9822e;\n  --accent-dark: #a56821;\n  --accent-light: #e0a050;\n  --background-color: #faf7f0;\n  --background-gradient: #faf7f0;\n  --brand-gradient: #1e3a5f;\n  --brand-gradient-hover: #152a47;\n  --brand-gradient-solid: #1e3a5f;\n  --brand-gradient-solid-hover: #152a47;\n  --brand-glow: rgba(30, 58, 95, 0.25);\n  --brand-glow-accent: rgba(201, 130, 46, 0.2);\n  --menu-item-hover-color: #152a47;\n  --menu-item-hover-bg: rgba(227, 233, 240, 0.9);\n  --card-background: #ffffff;\n  --menu-background: #ffffff;\n  --card-hover: #f1ece0;\n  --text-primary: #1a1a1a;\n  --text-secondary: #4a4a4a;\n  --text-tertiary: #8a8a8a;\n  --text-light: #faf7f0;\n  --border-color: rgba(30, 58, 95, 0.12);\n  --success-color: #10b981;\n  --warning-color: #c9822e;\n  --danger-color: #c0392b;\n  --box-shadow:\n    0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);\n  --box-shadow-md:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);\n  --box-shadow-lg:\n    0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);\n  --box-shadow-xl:\n    0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n  --box-shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  --transition-speed: 0.2s;\n  --transition-spring: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  --transition-smooth: cubic-bezier(0.4, 0, 0.2, 1);\n  --border-radius: 16px;\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 24px;\n  --border-radius-xl: 32px;\n  --glass-bg: #ffffff;\n  --glass-border: rgba(30, 58, 95, 0.08);\n  --backdrop-blur: none;\n  --navbar-height: 40px;\n  --navbar-total-height: 88px; /* navbar height + padding + increased gaps */\n  --group-tabs-height: 56px;\n  --navbar-rendered-height: var(--navbar-total-height);\n  --group-tabs-rendered-height: var(--group-tabs-height);\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-2xl: 3rem;\n}\n\n/* Dark mode theme */\n[data-theme='dark'] {\n  --background-color: #1a1815;\n  --background-gradient: #1a1815;\n  --card-background: #24211d;\n  --menu-background: #24211d;\n  --card-hover: #2e2a25;\n  --text-primary: #f0ebe0;\n  --text-secondary: #c4bfb5;\n  --text-tertiary: #8a8579;\n  --text-light: #1a1815;\n  --border-color: rgba(240, 235, 224, 0.1);\n  --glass-bg: #24211d;\n  --glass-border: rgba(240, 235, 224, 0.08);\n  --primary-color: #6b8cae;\n  --primary-dark: #5a7a9d;\n  --primary-light: #8fa6c0;\n  --primary-lighter: #2e3a4a;\n  --brand-gradient: #6b8cae;\n  --brand-gradient-hover: #8fa6c0;\n  --brand-gradient-solid: #6b8cae;\n  --brand-gradient-solid-hover: #8fa6c0;\n  --brand-glow: rgba(107, 140, 174, 0.4);\n  --brand-glow-accent: rgba(224, 160, 80, 0.3);\n  --menu-item-hover-color: #e0a050;\n  --menu-item-hover-bg: rgba(46, 42, 37, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
